@if (isDialogOpenState) {
  <!-- Backdrop -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
    (click)="closeDialog()"
    (keydown.esc)="closeDialog()"
    tabindex="0"
  >
    <!-- Dialog panel -->
    <div
      class="shadow-xl w-full max-w-md rounded-lg bg-white p-4"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      role="dialog"
    >
      <div class="flex items-start justify-between gap-3">
        <span class="text-lg font-bold text-gray-900">{{
          manual()?.title ?? ''
        }}</span>
        <button
          class="rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:ring-ocean-blue-300 focus:outline-none"
          (click)="closeDialog()"
          (keydown.enter)="closeDialog()"
          type="button"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
      <div
        class="text-sm text-gray-500 italic"
        [innerHTML]="manual()?.description ?? ''"
        style="margin-bottom: 10px"
      ></div>
      <a
        class="font-medium italic hover:underline"
        [href]="manualUrl"
        target="_blank"
      >
        {{
          'pages.articles.dialog.url'
            | translate: { chapter: manual()?.categoryTitle ?? '' }
        }}
      </a>
      <div class="text-sm text-gray-500 italic">
        {{ manual()?.preface ?? '' }}
      </div>
    </div>
  </div>
}
